import Vue from 'vue';

export function notify(message, options = {}) {
    Vue.$toast.open({
        message,
        type: 'default',
        duration: 3000,
        position: (screen.width < 992) ? 'bottom' : 'bottom-right',
        ...options,
    });
}

export function trans(langKey, replace = {}) {
    let line = window.FleetCart.langs[langKey];

    for (let key in replace) {
        line = line.replace(`:${key}`, replace[key]);
    }

    return line;
}

export function isEmpty(value) {
    return $.isEmptyObject(value);
}

export function chunk(array, size) {
    let chunkedArray = [];
    let index = 0;

    while (index < array.length) {
        chunkedArray.push(array.slice(index, size + index));
        index += size;
    }

    return chunkedArray;
}

export function slickPrevArrow() {
    if (window.FleetCart.rtl) {
        return `<div class="arrow-prev">
                    <i class="las la-angle-right"></i> ${trans('storefront::layout.prev')}
                </div>`;
    }

    return `<div class="arrow-prev">
                <i class="las la-angle-left"></i> ${trans('storefront::layout.prev')}
            </div>`;
}

export function slickNextArrow() {
    if (window.FleetCart.rtl) {
        return `<div class="arrow-next">
                    ${trans('storefront::layout.next')} <i class="las la-angle-left"></i>
                </div>`;
    }

    return `<div class="arrow-next">
                ${trans('storefront::layout.next')} <i class="las la-angle-right"></i>
            </div>`;
}

export function firstProductSlickPrevArrow() {
    if (window.FleetCart.rtl) {
        //return `<button class="firstprodctslick_next kfcPVH FrontpageCarousel__DesktopScrollButton-sc-16l46p6-1 hZYyaF"><svg width="12" height="12" stroke="grey20" class="Icon__SVG-sc-1pzq9fa-0 jKPquW" aria-hidden="true"><title></title><symbol viewBox="0 0 14 26" id="arrow"><path d="M13 1 1 13l12 12" stroke-width="1.8" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"></path></symbol></svg></button>`;
        return `<button class="firstprodctslick_next kfcPVH hZYyaF"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="12" height="12" x="0" y="0" viewBox="0 0 451.846 451.847" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M345.441 248.292 151.154 442.573c-12.359 12.365-32.397 12.365-44.75 0-12.354-12.354-12.354-32.391 0-44.744L278.318 225.92 106.409 54.017c-12.354-12.359-12.354-32.394 0-44.748 12.354-12.359 32.391-12.359 44.75 0l194.287 194.284c6.177 6.18 9.262 14.271 9.262 22.366 0 8.099-3.091 16.196-9.267 22.373z" fill="#000000" data-original="#000000" class=""></path></g></svg></button>`;

    }

    //return `<button class="firstprodctslick_prev hFACFU  hZYyaF"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="12" height="12" x="0" y="0" viewBox="0 0 55.753 55.753" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M12.745 23.915c.283-.282.59-.52.913-.727L35.266 1.581a5.4 5.4 0 0 1 7.637 7.638L24.294 27.828l18.705 18.706a5.4 5.4 0 0 1-7.636 7.637L13.658 32.464a5.367 5.367 0 0 1-.913-.727 5.367 5.367 0 0 1-1.572-3.911 5.369 5.369 0 0 1 1.572-3.911z" fill="#000000" data-original="#000000" class=""></path></g></svg></button>`;
    return `<button class="firstprodctslick_next kfcPVH hZYyaF"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="12" height="12" x="0" y="0" viewBox="0 0 451.846 451.847" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M345.441 248.292 151.154 442.573c-12.359 12.365-32.397 12.365-44.75 0-12.354-12.354-12.354-32.391 0-44.744L278.318 225.92 106.409 54.017c-12.354-12.359-12.354-32.394 0-44.748 12.354-12.359 32.391-12.359 44.75 0l194.287 194.284c6.177 6.18 9.262 14.271 9.262 22.366 0 8.099-3.091 16.196-9.267 22.373z" fill="#000000" data-original="#000000" class=""></path></g></svg></button>`;

}

export function firstProductSlickNextArrow() {
    if (window.FleetCart.rtl) {
        //return `<button class="firstprodctslick_prev hFACFU FrontpageCarousel__DesktopScrollButton-sc-16l46p6-1 hZYyaF"><svg width="12" height="12" stroke="grey20" class="Icon__SVG-sc-1pzq9fa-0 jKPquW" aria-hidden="true"><title></title><use href="#arrow" xlink:href="#arrow"></use></svg></button>`;
        return `<button class="firstprodctslick_prev hFACFU  hZYyaF"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="12" height="12" x="0" y="0" viewBox="0 0 55.753 55.753" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M12.745 23.915c.283-.282.59-.52.913-.727L35.266 1.581a5.4 5.4 0 0 1 7.637 7.638L24.294 27.828l18.705 18.706a5.4 5.4 0 0 1-7.636 7.637L13.658 32.464a5.367 5.367 0 0 1-.913-.727 5.367 5.367 0 0 1-1.572-3.911 5.369 5.369 0 0 1 1.572-3.911z" fill="#000000" data-original="#000000" class=""></path></g></svg></button>`;

    }
    return `<button class="firstprodctslick_prev hFACFU  hZYyaF"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="12" height="12" x="0" y="0" viewBox="0 0 55.753 55.753" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M12.745 23.915c.283-.282.59-.52.913-.727L35.266 1.581a5.4 5.4 0 0 1 7.637 7.638L24.294 27.828l18.705 18.706a5.4 5.4 0 0 1-7.636 7.637L13.658 32.464a5.367 5.367 0 0 1-.913-.727 5.367 5.367 0 0 1-1.572-3.911 5.369 5.369 0 0 1 1.572-3.911z" fill="#000000" data-original="#000000" class=""></path></g></svg></button>`;

    //return `<button class="firstprodctslick_next kfcPVH hZYyaF"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="12" height="12" x="0" y="0" viewBox="0 0 451.846 451.847" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M345.441 248.292 151.154 442.573c-12.359 12.365-32.397 12.365-44.75 0-12.354-12.354-12.354-32.391 0-44.744L278.318 225.92 106.409 54.017c-12.354-12.359-12.354-32.394 0-44.748 12.354-12.359 32.391-12.359 44.75 0l194.287 194.284c6.177 6.18 9.262 14.271 9.262 22.366 0 8.099-3.091 16.196-9.267 22.373z" fill="#000000" data-original="#000000" class=""></path></g></svg></button>`;
}
